export const LOAD_BATCH_SIZE = 100;

export function calculateRequiredRanges(firstVisible, lastVisible, loadedItems, activeLoadingRanges, totalItems) {
    const requiredRanges = [];
    let unloadedStart = null;

    // Check each index in visible range
    for (let i = firstVisible; i <= lastVisible; i++) {
        const isLoaded = loadedItems.has(i);

        if (!isLoaded) {
            if (unloadedStart === null) {
                unloadedStart = i;
            }
        } else if (unloadedStart !== null) {
            // End of unloaded section
            addBatchAlignedRange(unloadedStart, requiredRanges, activeLoadingRanges, totalItems);
            unloadedStart = null;
        }
    }

    // Handle unloaded section at end
    if (unloadedStart !== null) {
        addBatchAlignedRange(unloadedStart, requiredRanges, activeLoadingRanges, totalItems);
    }

    return requiredRanges;
}

function addBatchAlignedRange(start, ranges, activeLoadingRanges, totalItems) {
    // Align to batch boundaries
    const batchStart = Math.floor(start / LOAD_BATCH_SIZE) * LOAD_BATCH_SIZE;
    const batchEnd = Math.min(batchStart + LOAD_BATCH_SIZE - 1, totalItems - 1);

    const rangeKey = `${batchStart}-${batchEnd}`;

    // Only add if not already loading
    if (!activeLoadingRanges.has(rangeKey)) {
        ranges.push({ start: batchStart, end: batchEnd });
    }
}

export function isRangeFullyLoaded(range, loadedRanges) {
    return loadedRanges.some(loaded => loaded.start <= range.start && loaded.end >= range.end);
}

export function mergeLoadedRanges(ranges) {
    if (ranges.length === 0) return [];

    const sorted = [...ranges].sort((a, b) => a.start - b.start);
    const merged = [];
    let current = { ...sorted[0] };

    for (let i = 1; i < sorted.length; i++) {
        const next = sorted[i];
        if (next.start <= current.end + 1) {
            // Overlapping or adjacent - merge
            current.end = Math.max(current.end, next.end);
        } else {
            // Gap - start new range
            merged.push(current);
            current = { ...next };
        }
    }

    merged.push(current);
    return merged;
}

export default {
    LOAD_BATCH_SIZE,
    calculateRequiredRanges,
    isRangeFullyLoaded,
    mergeLoadedRanges
};
